import cache from './cache.js';
import getOperatingSystem from './getOperatingSystem.js';

export default cache('isWindows', function isWindows() {
  return getOperatingSystem().name.includes('Windows');
});